import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Container } from '@mui/material';
import AppAppBar from '../../components/layout/AppAppBar';
import coinStackingGif from '../../assets/coin-stacking_20260102111635.gif';

export default function PaymentProcessingPageFb() {

    useEffect(() => {
        // Guard: Check if user is coming from the Facebook flow
        const isFbUser = sessionStorage.getItem('fb_user') === 'true' ||
            sessionStorage.getItem('ad_source') === 'facebook';

        if (!isFbUser) {
            console.warn('Unauthorized access to FB payment processing page. Redirecting...');
            window.location.href = '/';
            return;
        }

        // Simulate processing time then redirect
        const timer = setTimeout(() => {
            sessionStorage.setItem('payment_processed', 'true');
            window.location.href = '/payment-success-fb';
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
            <Helmet>
                <title>Payment Status | App20</title>
            </Helmet>
            {/* Common Navbar */}
            <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} />

            <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
                <Typography
                    variant="h4"
                    sx={{
                        mb: 4,
                        fontWeight: 800,
                        fontFamily: 'General-Sans-bold',
                        color: '#000',
                        position: 'relative',
                        display: 'inline-block',
                        zIndex: 1
                    }}
                >
                    Payment Status
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: '6px',
                            right: '-5px',
                            width: '60%',
                            height: '14px',
                            bgcolor: '#FFC107',
                            zIndex: -1,
                            borderRadius: '20px'
                        }}
                    />
                </Typography>

                {/* Coin Stacking GIF */}
                <Box sx={{ width: 250, height: 250, mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                        src={coinStackingGif}
                        alt="Processing payment"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }}
                    />
                </Box>

                <Typography variant="h5" sx={{ color: '#3F51B5', fontWeight: 700, mb: 2 }}>
                    Processing Payment
                </Typography>

                <Typography variant="body2" sx={{ textAlign: 'center', color: '#757575', maxWidth: 300 }}>
                    {
                        "Note: Wait for 24 hours to recieve your payment."
                    }
                </Typography>
            </Container>
        </Box>
    );
}
